import { render } from "./Index.vue?vue&type=template&id=7afc368f&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=7afc368f&lang=css"
import "./Index.vue?vue&type=style&index=1&id=7afc368f&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=2&id=7afc368f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7afc368f"

export default script